import type { NavigateFunction } from 'react-router/lib/hooks';

class RouterState {
  public navigateFn: NavigateFunction | null = null;
}

export { RouterState };
